// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".failed-auth{margin:50px auto;width:500px;text-align:center}", ""]);
// Exports
module.exports = exports;
